class HbsBorcTaahhutDTO {
    id: number = null;
    kimlikId?: number = null;
    muracaatId?: number = null;
    tarih?: string = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    borcToplam?: number = null;
    odenenToplam?: number = null;
    iptal?: string = "";
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    iptalBool?: boolean = false;
    islemler?: Array<number> = []
}
export default HbsBorcTaahhutDTO;